import * as React from 'react'
import { Link, Route, RouteComponentProps } from 'react-router-dom'
import Plus from '../icons/organizations/Plus'
import AddColorModal from '../../containers/global-settings/AddColorModal'
import EditColorModal from './EditColorModal'
import RemoveColorModal from '../../containers/global-settings/RemoveColorModal'
import SettingList from './SettingList'
import { IVehicleColor } from 'src/types'
import BackToList from '../ui/BackToList'

interface IColorPaneProps extends RouteComponentProps {
  colors: IVehicleColor[]
}

export default class ColorPane extends React.Component<IColorPaneProps> {
  public render() {
    const colors = []
    for (const index of Object.keys(this.props.colors)) {
      const color = this.props.colors[index]
      colors.push({
        label: color.name,
        id: color.id
      })
    }

    return (
      <React.Fragment>
        <Route path={`${this.props.match.path}/create`} component={AddColorModal} />
        <Route path={`${this.props.match.path}/remove/:id`} component={RemoveColorModal} />
        <Route path={`${this.props.match.path}/edit/:id`} component={EditColorModal} />
        <BackToList link='/global-settings' className='flex' />
        <div className='pt3'>
          <div className='flex justify-between mb2'>
            <div className='pl3 h3 bold font-blue-grey'>Color</div>
            <Link
              className='btn bg-green rounded font-white mr2 flex justify-center items-center'
              to='/global-settings/color/create'
            >
              <Plus className='svg-white mr1' />
              Add Color
            </Link>
          </div>
          <hr />
          <div>
            <p className='h5 bold pl2 font-black'>Color List</p>
            <div className='pl3 pr3 col-4'>
              <SettingList baseUrl={this.props.match.path} settings={colors} />
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/ColorPane.tsx